export const upgradeContainer = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',

  '.upgrade-img': {
    maxWidth: '100%',
  },
};

export const upgradeHead = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '12px',
  width: "100%",
  paddingBottom: '20px',
  marginBottom: '20px',
  borderBottom: '1px solid var(--grey200)',
};

export const listItem = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'flex-start',
  gap: '7px',
  marginBottom: '12px',
  textAlign: 'left',
};

export const upgradeButton = {
  background: 'var(--primary)',
  padding: '8px 20px',
  borderRadius: '20px',
  fontWeight: '500',
  fontSize: '18px',
  color: 'var(--white)',
  marginTop: '24px',
};
